
import { Container, Card, CardContent } from "@mui/material"

import { TokenUnico } from "../ui/TokenUnico";
import { NavbarInicio } from "../ui/NavbarInicio"

export const TokenUnicoScreen = () => {    

    return (

        <>

            <NavbarInicio />

            <Container 
                maxWidth="md"
                sx={{ 
                    minHeight: 'calc(100vh - 20px)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    pt: { md: 8, xs: 12 }
                }}
            >
                
                <Card 
                    elevation={4} 
                    sx={{ 
                        p: { md: 5, xs: 3 }, 
                        borderRadius: 3,
                        width: '100%',
                        maxWidth: 750
                    }}
                >

                    <CardContent>

                        <TokenUnico dialog={ false } />

                    </CardContent>

                </Card>

            </Container>

        </>

    )
}